// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchButton_search__25nST"};